import React from "react";
import { Switch } from "react-router-dom";
import MarketingHome from "components/Pages/Admin/Marketing/Marketing";
import SMSBatchEditor from "components/Pages/Admin/Marketing/SMSBatching/SMSBatchEditor";
import SMSFileUpload from "components/Pages/Admin/Marketing/SMSBatching/SMSFileUpload";
import SMSReview from "components/Pages/Admin/Marketing/SMSBatching/SMSReview";
import SMSResults from "components/Pages/Admin/Marketing/SMSBatching/SMSResults";
import PushBatchEditor from "components/Pages/Admin/Marketing/PushBatching/PushBatchEditor";
import SMSAnalytics from "components/Pages/Admin/Marketing/SMSBatching/SMSAnalytics";
import PushFileUpload from "components/Pages/Admin/Marketing/PushBatching/PushFileUpload";
import PushReview from "components/Pages/Admin/Marketing/PushBatching/PushReview";
import PushResults from "components/Pages/Admin/Marketing/PushBatching/PushResults";
import EmailBatchEditor from "components/Pages/Admin/Marketing/EmailBatching/EmailBatchEditor";
import EmailFileUpload from "components/Pages/Admin/Marketing/EmailBatching/EmailFileUpload";
import EmailReview from "components/Pages/Admin/Marketing/EmailBatching/EmailReview";
import EmailResults from "components/Pages/Admin/Marketing/EmailBatching/EmailResults";
import EmailAnalytics from "components/Pages/Admin/Marketing/EmailBatching/EmailAnalytics";
import AdminRouteRaw from "../../AuthRoutes/Admin";

const rootPath = 'marketing';

const AdminRoute = (props) => (
  <AdminRouteRaw renderLayout={false} {...props} />
);

const AppRoutes = () => (
  <Switch>
    <AdminRoute exact path={`/${rootPath}/email`} component={EmailBatchEditor} />
    <AdminRoute
      exact
      path={`/${rootPath}/email/upload`}
      component={EmailFileUpload}
    />
    <AdminRoute
      exact
      path={`/${rootPath}/email/results`}
      component={EmailResults}
    />
    <AdminRoute exact path={`/${rootPath}/email/review`} component={EmailReview} />
    <AdminRoute
      exact
      path={`/${rootPath}/email/analytics`}
      component={EmailAnalytics}
    />
    <AdminRoute exact path={`/${rootPath}/sms`} component={SMSBatchEditor} />
    <AdminRoute exact path={`/${rootPath}/sms/upload`} component={SMSFileUpload} />
    <AdminRoute exact path={`/${rootPath}/sms/review`} component={SMSReview} />
    <AdminRoute exact path={`/${rootPath}/sms/results`} component={SMSResults} />
    <AdminRoute
      exact
      path={`/${rootPath}/sms/analytics`}
      component={SMSAnalytics}
    />
    <AdminRoute exact path={`/${rootPath}/push`} component={PushBatchEditor} />
    <AdminRoute
      exact
      path={`/${rootPath}/push/upload`}
      component={PushFileUpload}
    />
    <AdminRoute exact path={`/${rootPath}/push/review`} component={PushReview} />
    <AdminRoute exact path={`/${rootPath}/push/results`} component={PushResults} />
    <AdminRoute exact path={`/${rootPath}`} component={MarketingHome} />
  </Switch>
);

export default AppRoutes;
